import React from 'react';
import { FulfillmentOrdersExpandListTemplate } from 'themes/modules/order/pages';
import { FulfillmentOrdersExpandListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new FulfillmentOrdersExpandListViewStore(rootStore, componentProps),
	'fulfillmentOrdersExpandListViewStore'
)
class FulfillmentOrdersExpandList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<FulfillmentOrdersExpandListTemplate
				{...this.props}
				fulfillmentOrdersExpandListViewStore={this.props.fulfillmentOrdersExpandListViewStore}
			/>
		);
	}
}

export default FulfillmentOrdersExpandList;



// WEBPACK FOOTER //
// ./src/modules/order/pages/FulfillmentOrdersExpandList.jsx